const staging = {
    API_ROOT: 'https://adminpanel-staging.amygbdemos.in/api/',
    WS_ROOT: 'https://adminpanel-staging.amygbdemos.in/'
}
const dev = {
    API_ROOT: 'https://adminpanel.amygbdemos.in/api/',
    WS_ROOT: 'https://adminpanel.amygbdemos.in/'
}

const pl = {
    API_ROOT: 'https://plbackend.amygbdemos.in/api/',
    WS_ROOT: 'https://plbackend.amygbdemos.in/'
}


const loadBalancer = {
    API_ROOT: 'https://aclb.amygbdemos.in/api/',
    WS_ROOT: 'https://aclb.amygbdemos.in/'
}

export default process.env.REACT_APP_STAGE === 'development' ? dev : (process.env.REACT_APP_STAGE === 'lb' ? loadBalancer : (
    process.env.REACT_APP_STAGE === 'pl' ? pl : staging
));
